import { render, staticRenderFns } from "./CardLogs.vue?vue&type=template&id=2126496a&scoped=true&"
import script from "./CardLogs.vue?vue&type=script&lang=js&"
export * from "./CardLogs.vue?vue&type=script&lang=js&"
import style0 from "./CardLogs.vue?vue&type=style&index=0&id=2126496a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2126496a",
  null
  
)

export default component.exports